<template>
    <PageContainer>

        <Breadcrumbs :breadcrumbs="breadcrumbs" />

        <div
            v-if="shouldLoadMentionMeScript"
            id="mmWrapper"
        />

        <CategoryImageHeading
            v-if="page.image.sizes.large"
            :image="page.image.sizes.large"
            class="mb-6"
        />

        <div
            v-if="page.content"
            class="html"
            v-html="page.content"
        />

        <CatalogueRow
            v-for="(row, index) in page.rows"
            :key="index"
            :tiles="row.tiles"
            :name="row.show_name ? row.name : null"
            :url="row.url"
        />

    </PageContainer>
</template>

<script>
import Breadcrumbs from '~/components/Breadcrumbs';
import CategoryImageHeading from '~/components/CategoryImageHeading';
import CatalogueRow from '~/components/CatalogueRow';
import PageContainer from '@/components/PageContainer.vue';

export default {

    components: {
        PageContainer,
        Breadcrumbs,
        CategoryImageHeading,
        CatalogueRow,
    },

    async asyncData({ $axios, query, params, error, redirect }) {
        const queryString = query.preview_token ? `?preview_token=${query.preview_token}` : '';
        return $axios.$get(`/pages/${params.slug}${queryString}`)
            .then((page) => ({
                breadcrumbs: [
                    {
                        name: 'Home',
                        link: '/',
                    },
                    {
                        name: page.name,
                        link: '',
                    },
                ],
                page,
            }))
            .catch((e) => $axios.post('pages/missing', {
                path: `/${params.slug}`,
            }).then((response) => {
                redirect(response.data.type, `https://bubblegumballoons.com${response.data.redirect}`);
            }).catch((err) => error({ statusCode: err.response.status })));
    },

    data() {
        return {
            page: {},
            breadcrumbs: [],
        };
    },

    computed: {
        shouldLoadMentionMeScript() {
            return this.$route.params.slug === 'referral';
        },
    },

    mounted() {
        if (this.shouldLoadMentionMeScript) {
            this.loadMentionMeScript();
        }
    },

    methods: {
        loadMentionMeScript() {
            const src = 'https://tag.mention-me.com/api/v2/referreroffer/mm8d73a512?situation=landingpage&locale=en_GB';
            const mentionMeScript = document.createElement('script');
            mentionMeScript.setAttribute('src', src);
            document.body.appendChild(mentionMeScript);
        },
    },

    head() {
        return {
            title: this.page.meta_title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.page.meta_description,
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.page.meta_title,
                },
            ],
        };
    },

};
</script>

<style lang="scss" scoped>
</style>
